import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect } from "react";
import { Loading } from "@/components/atoms";

/**
 * LogoutCallback - Handles the final Kinde logout after PHP session is cleared
 *
 * Flow:
 * 1. User clicks logout in the new UI
 * 2. User is redirected to PHP /logout endpoint to clear PHP session
 * 3. PHP /logout redirects back to this /logout-callback route
 * 4. This component triggers Kinde logout
 * 5. Kinde redirects to /login (configured as logoutUri in App.tsx)
 */
export const LogoutCallback = () => {
  const { logout } = useKindeAuth();

  useEffect(() => {
    // Trigger Kinde logout immediately when this component mounts
    logout();
  }, [logout]);

  return <Loading />;
};
